export class QuestionSetLabel
{
	private _id:string;
	private _display_order:number;
	private _label:string;
	private _skipScoring:boolean;
	
	constructor() {
		this.id = null;
		this.display_order = 0;
		this.label = "";
	}
	
	public get id():string {
		return this._id;
	}
	public set id(id:string) {
		this._id = id;
	}
	
	public get skipScoring():boolean {
		return this._skipScoring;
	}
	public set skipScoring(id:boolean) {
		this._skipScoring = id;
	}
	
	public get display_order():number {
		return this._display_order;
	}
	public set display_order(order:number) {
		this._display_order = order;
	}
	
	public get label() : string {
		return this._label;
	}
	
	public set label(lbl:string) {
		this._label = lbl;
	}
}


// WEBPACK FOOTER //
// ./src/app/shared/models/question-set-label.ts